import React from 'react';
import ReactDOM from 'react-dom';

import ReactDOMServer from 'react-dom/server'

import Checkout from './Components/checkout/components/Checkout'
import RoiCalculator from './Components/roi-calculator/RoiCalculator'

global['React'] = React
global['ReactDOM'] = ReactDOM
global['ReactDOMServer'] = ReactDOMServer

global['Checkout'] = Checkout
global['RoiCalculator'] = RoiCalculator

const parsePropsFromJsonScript = (scriptId) => {
	const script = document.getElementById(scriptId);
	if (!script) {
		return null;
	}

	try {
		return JSON.parse(script.textContent || '{}');
	} catch (error) {
		console.error(`Unable to parse React props from #${scriptId}`, error);
		return null;
	}
};

const mountComponent = (mountId, Component, propsScriptId) => {
	const mountNode = document.getElementById(mountId);
	if (!mountNode) {
		return;
	}

	const props = parsePropsFromJsonScript(propsScriptId) || {};
	ReactDOM.render(<Component {...props} />, mountNode);
};

if (typeof document !== 'undefined') {
	mountComponent('checkoutPage', Checkout, 'checkout-props-json');
	mountComponent('roiCalculatorPage', RoiCalculator, 'roi-calculator-props-json');
}


//import registerServiceWorker from './registerServiceWorker';

//registerServiceWorker();
    